import React from 'react';
import { Helmet } from 'react-helmet-async';

import { useTranslate } from 'src/shared/hooks';
import { TranslationNamespace } from 'src/shared/hooks/useTranslate';

import favicon from 'assets/img/favicon.png';

export const Meta = ({ imageUrl }: { imageUrl: string | undefined }) => {
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <meta content={t('share.metaTitle')} property="og:title" />
      <meta content={imageUrl} property="og:image" />
      <link href={favicon} rel="icon" />
    </Helmet>
  );
};
